import{useSelector}from'react-redux';const useDocumentLanguage=()=>{return useSelector(state=>state.documentLanguage);};export default useDocumentLanguage;